import React from 'react';
import { MemberTypeCircleBadge } from '@/components/ui/member-type-circle-badge';
import { MemberTypeRecord } from '@/types/member';

interface MemberTypeBadgesLocalProps {
  types: MemberTypeRecord[];
  primaryTypeOnly?: boolean;
}

export const MemberTypeBadgesLocal: React.FC<MemberTypeBadgesLocalProps> = ({ 
  types = [], 
  primaryTypeOnly = false 
}) => {
  if (!types || types.length === 0) {
    return null;
  }

  // Trier : primaire en premier
  const sortedTypes = [...types].sort((a, b) => 
    (b.is_primary ? 1 : 0) - (a.is_primary ? 1 : 0)
  );

  const primaryType = sortedTypes.find(t => t.is_primary);
  const secondaryTypes = sortedTypes.filter(t => !t.is_primary);

  if (primaryTypeOnly && primaryType) {
    return (
      <MemberTypeCircleBadge
        type={primaryType.type as any}
        size="md"
        variant="primary"
      />
    );
  }

  return (
    <div className="flex gap-0.5 items-center flex-wrap">
      {primaryType && (
        <MemberTypeCircleBadge
          type={primaryType.type as any}
          size="md"
          variant="primary"
        />
      )}
      {secondaryTypes.slice(0, 2).map((type) => (
        <MemberTypeCircleBadge
          key={type.id}
          type={type.type as any}
          size="sm"
          variant="secondary"
        />
      ))}
      {secondaryTypes.length > 2 && (
        <div className="w-5 h-5 rounded-full bg-muted text-[10px] flex items-center justify-center text-muted-foreground border border-border">
          +{secondaryTypes.length - 2}
        </div>
      )}
    </div>
  );
};
